import React from 'react';
import { Route, Routes as RoutesProvider } from 'react-router-dom';
import { HomeTemplate } from '../components/templates/home.template';
import { PixTemplate } from '../components/templates/pix.template';
import { ObrigadoTemplate } from '../components/templates/obrigado.template';
import { CarregarPagamentoTemplate } from '../components/templates/carregar-pagamento.template';
import { CompraRecusadaTemplate } from '../components/templates/compra-recusada.template';
import { BoletoTemplate } from '../components/templates/boleto.template';
import { UpSellTemplate } from '../components/templates/up-sell.template';
import { UpSellCardIframePage } from '../components/templates/up-sell-iframe.template';
import { SolicitarReembolsoTemplate } from '../components/templates/solicitar-reembolso.template';
import { AmazonPayReturnTemplate } from '../components/templates/amazon-pay-return.template';

export const Routes = () => {
  return (
    <RoutesProvider>
      <Route path="/:id" element={<HomeTemplate />} />
      <Route path="/venda/pix" element={<PixTemplate />} />
      <Route
        path="/venda/processando"
        element={<CarregarPagamentoTemplate />}
      />
      <Route path="/venda/obrigado" element={<ObrigadoTemplate />} />
      <Route path="/venda/recusado" element={<CompraRecusadaTemplate />} />
      <Route
        path="/venda/compra-recusada/:id"
        element={<CompraRecusadaTemplate />}
      />
      <Route path="/venda/boleto" element={<BoletoTemplate />} />
      <Route
        path="/venda/amazon-pay-return"
        element={<AmazonPayReturnTemplate />}
      />
      <Route path="/obrigado/:id" element={<AmazonPayReturnTemplate />} />
      <Route path="/up-sell/:id" element={<UpSellTemplate />} />
      <Route
        path="/up-sell/credit-card/:upsellId"
        element={<UpSellCardIframePage />}
      />
      <Route path="/solicitar-reembolso" element={<SolicitarReembolsoTemplate />} />
    </RoutesProvider>
  );
};
